/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useEffect, useState } from "react";
// import { API } from "../../../globals/globals";
// import { useExportEventsMutation, useGetEventsQuery } from "../../../store/api/devices/deviceApiSlice";
// import { urlParameterSelector } from "../../../store/filters/events/EventFilterSelectors";
import { useSelector } from "react-redux";
// import { eventsColumns } from "../../../components/Shared/Table/Columns";
import { useLocation } from "react-router-dom";
import { deviceSiteGroupSelector, selectedGeoRegionSelector } from "../../../../store/filters/Nodes/selectors";
import { useStoreDispatch } from "../../../../store/hooks";
import { eventFilterSelector, urlRedundancySelector } from "./RedundancyFilterSelector";
import { searchKeywordSelector } from "../../../../store/search/selector";
import { paginationModelSelector, selectedNavListItemSelector } from "../../../../store/helpers/helperSelectors";
import { useExportEventsMutation, useGetEventsQuery } from "../../../../store/api/devices/deviceApiSlice";
import { initialState } from "../../../../store/helpers/helperInitialState";
import { ALARMSEVERITYLIST, API, SEVERITYLIST } from "../../../../globals/globals";
import { setDeviceCount, setOpenToast } from "../../../../store/helpers/helperReducers";
import { errorMessage, exportInCSV } from "../../../../utils/helpers";
import { eventsColumns } from "../../../Shared/Table/Columns";
import { IFilterSelectBox } from "../../../Shared/Filter/types";
import { setSelectedEventSeverity } from "../../../../store/filters/events/EventFilterReducer";
import { selectedTypeSelector } from "../../../../store/api/devices/selectors";
import { SxProps } from "@mui/material";
// import { searchKeywordSelector } from "../../../store/search/selector";
// import { setDeviceCount, setOpenToast } from "../../../store/helpers/helperReducers";
// import { useStoreDispatch } from "../../../store/hooks";
// import { paginationModelSelector, selectedNavListItemSelector } from "../../../store/helpers/helperSelectors";
// import { errorMessage, exportInCSV } from "../../../utils/helpers";
// import { deviceSiteGroupSelector } from "../../../store/filters/Nodes/selectors";
// import { initialState } from "../../../store/helpers/helperInitialState";
// import { selectedGeoRegionSelector } from "../../../store/filters/Nodes/selectors";

export const useRedundancyDisplay = () => {
  const geoRegion = useSelector(selectedGeoRegionSelector);
  const dispatch = useStoreDispatch();
  const location = useLocation();

  const locationPath = location?.pathname.split("/");
  const filters = useSelector(urlRedundancySelector);
  const keyword = useSelector(searchKeywordSelector);

  //filter events based on the selected group
  const selectedGroupKey = useSelector(selectedNavListItemSelector);
  const selectedGroupKeyValue = useSelector(deviceSiteGroupSelector);

  const { eventDisplay = initialState.pagination } = useSelector(paginationModelSelector);
  const [exportEvents, exportStatus] = useExportEventsMutation();
  const [sortOrder, setSortOrderToEvent] = useState("retention,desc");

  filters.set("sort", sortOrder);
  filters.set("page", eventDisplay.page.toString());
  filters.set("size", eventDisplay.pageSize.toString());
  filters.set("search", keyword);
  filters.has("isAlarm") && filters.delete("isAlarm");

  switch (selectedGroupKey) {
    case "devices": {
      filters.set("deviceSpecs", "");
      break;
    }
    case "disconnected": {
      filters.set("deviceSpecs", "");
      break;
    }
    case "maintenancemode": {
      filters.set("deviceSpecs", "");
      break;
    }
    case "pmCollected": {
      filters.set("deviceSpecs", "");
      break;
    }

    case "ungrouped": {
      // filters.set("deviceSpecs", "parentKey,''");
      break;
    }

    default: {
      if (!!selectedGroupKey) {
        filters.set("deviceSpecs", "");
        // filters.set("deviceSpecs", `parentKey,${selectedGroupKeyValue}`);
      }
      break;
    }
  }

  let args:any;
  // if (locationPath.includes("device")) {
  //   args = { filters: filters.toString(), deviceKey: locationPath[2] };
  // } else {
  args = { filters: filters.toString() };
  // }
  const { data, isLoading, refetch } = useGetEventsQuery(args, {
    pollingInterval: API.ENDPOINTS.EVENTS.pollingInterval || API.POLLING_INTERVAL,
  });

  useEffect(() => {
    refetch();
  }, [filters, refetch]);

  useEffect(() => {
    dispatch(
      setDeviceCount({
        disconnectedDeviceCount: Number(localStorage.getItem("disconnected")),
        allDeviceCount: Number(localStorage.getItem("allDevice")),
        inMaintenanceModeCount: Number(localStorage.getItem("inMaintenanceMode")),
        ungroupedCount: Number(localStorage.getItem("ungrouped")),
        kpiSyncErrorCount: Number(localStorage.getItem("kpiErorrCount")),
        offLineDeviceCount: Number(localStorage.getItem("offLineDeviceCount")),
      })
    );
  }, [dispatch]);

  const exportHandler = async () => {
    try {
      const response: any = await exportEvents(args);

      if (response?.error) throw response?.error;
      exportInCSV(response, "Events");
    } catch (error: any) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  return {
    data,
    isLoading,
    eventsColumns,
    exportHandler,
    exportStatus,
    setSortOrderToEvent,
  };
};


export const useActivityLogFilter = () => {

  const dispatch = useStoreDispatch();
  const eventFilterData = useSelector(eventFilterSelector);
  const location = useLocation();
  const alarmPath = location?.pathname?.split("/")[2];
  const selectedTypeOnDeviceDetail = useSelector(selectedTypeSelector)

  const eventFilters: IFilterSelectBox[] = [
      {
        id: "severity",
        label: "SEVERITY",
        value: eventFilterData.selectedEventSeverity || "",
        setValue: setSelectedEventSeverity,
        values: alarmPath === "alarms" ? ALARMSEVERITYLIST : selectedTypeOnDeviceDetail === "alarms" ? ALARMSEVERITYLIST : SEVERITYLIST,
        width: "120px",
      },
  ]

const formControlSx: SxProps = { minWidth: 100, marginRight: "10px" };
  const searchTooltip = "Search by 'Host', 'Type', 'Managed Object' or  'Description', fields for quick access.";
  
  return {
    dispatch,
    eventFilters,
    formControlSx,
    searchTooltip
  }
}